class ActionType {
    static QUERY = 'query';
    static RESET = 'reset';
    static SEARCH = 'search';
    static CONFIRM = 'confirm';
    static CANCEL = 'cancel';
    static CLOSE = 'close';
}

export default ActionType;